<template>
  <form>
    <div class="grid grid-cols-[84px_256px] phone:grid-cols-2 items-center gap-x-4 mb-2">
      <p>
        {{ $t('common.regularity') }}
      </p>
      <wui-select
        v-model="selectedRegularity"
        :items="regularity"
      />
    </div>
    <div
      v-if="selectedRegularity === 'One time'"
      class="grid grid-cols-[84px_256px] phone:grid-cols-2 items-center mb-2 gap-x-4"
    >
      <p>
        {{ $t('common.date') }}
      </p>
      <slot name="date" />
    </div>
    <div
      v-if="selectedRegularity === 'Select days'"
      class="grid grid-cols-[84px_256px] phone:grid-cols-2 items-center mb-2 gap-x-4"
    >
      <p>
        {{ $t('common.weekDays') }}
      </p>
      <slot name="days" />
    </div>
    <div class="grid grid-cols-[84px_256px] phone:grid-cols-2 items-center mb-2 gap-x-4">
      <p>
        {{ $t('common.time') }}
      </p>
      <slot name="time" />
    </div>
    <div class="grid grid-cols-[84px_256px] phone:grid-cols-2 items-center mb-2 gap-x-4">
      <p>
        {{ $t('common.description') }}*
      </p>
      <slot name="name" />
    </div>
    <div class="grid grid-cols-[84px_256px] phone:grid-cols-1 mb-2 gap-x-4">
      <p>
        {{ $t('common.audioFile') }}
      </p>
      <div class="space-y-2">
        <slot name="prompts" />
        <slot
          name="player"
        />
      </div>
    </div>
  </form>
</template>
<script setup lang="ts">

import { SelectItem, WuiSelect } from '@wui/common-library'
import { computed, ref, watch } from 'vue'

import { RegularityValue } from '@/entities/alarm'

import { useLocalization } from '@/shared/composables/localization'

const { t } = useLocalization()

const props = defineProps<{
  initialRegularity?: RegularityValue
}>()

const emits = defineEmits<{
  (event: 'change-regularity', value: RegularityValue): void
}>()

const regularity = computed<SelectItem[]>(() => [{ label: `${t('common.oneTime')}`, value: 'One time' }, { label: `${t('common.selectDays')}`, value: 'Select days' }])
const selectedRegularity = ref<RegularityValue>(props.initialRegularity ?? 'One time')

watch(() => selectedRegularity.value, (value) => {
  emits('change-regularity', value)
})

emits('change-regularity', selectedRegularity.value)
</script>
